<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <div class="col-sm-12 col-md-12">
        <TableSearch @handleSearch="handleSearch" left="left:16px" />
      </div>
      <div class="row" style="height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead class="data-table-bg">
              <tr>
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <!-- <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span> -->
                </th>
              </tr>
            </thead>
            <tbody v-if="stats.length > 0 && this.dataCheck">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="cursor: pointer; text-align: left;"
                :class="{
                  'data-table-bg': index % 2 !== 0,
                }"
              >
                <td>
                  <div style="display:flex; justify-content: left" class="pt-2">
                    <!-- <div
                      v-if="!data.column1"
                      style="height: 0.8rem; width: 0.8rem; border-radius: 0.4rem"
                      class="bg-secondary"
                    ></div> -->
                    <div
                      v-if="data.date && data.column1 === 'good'"
                      style="height: 0.8rem; width: 0.8rem; border-radius: 0.4rem"
                      class="bg-success"
                    ></div>
                    <div
                      v-else-if="data.date && data.column1 === 'critical'"
                      style="height: 0.8rem; width: 0.8rem; border-radius: 0.4rem"
                      class="bg-danger"
                    ></div>
                  </div>
                </td>
                <td>{{ data.column2 }}</td>
                <td>{{ data.column3 }}</td>
                <td>{{ data.date }}</td>
              </tr>
            </tbody>
            <tbody v-else-if="this.stats.length !== 0 && !this.dataCheck">
              <tr>
                <td colspan="6">
                  {{ $t("no-search") }}
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6">
                  {{ $t("no-dev") }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <PaginationNew
        :pageCount="pageCount"
        :data="paginatedData"
        :sizeperpage="sizeperpage"
        :pageNumber="pageNumber"
        :pages="pages"
        @goToLastPage="goToLastPage"
        @nextPage="nextPage"
        @handlePageChange="handlePageChange"
        @goToFirstPage="goToFirstPage"
        @prevPage="prevPage"
        @onchange="onchange"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import tableMixin from "../mixins/tableMixin";
import PaginationNew from "./PaginationNew.vue";
import TableSearch from "./TableSearch.vue";

export default {
  name: "DeviceExcursionTable",
  props: {
    stats: Array,
  },
  data() {
    return {
      dataTable: [],
      dataCheck: true,
    };
  },
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        const data = this.stats.map((item) => ({
          column1: item.status,
          column2: item.duration,
          column3: item.temperature,
          date: moment(item.lastupdated).format("MMM Do YYYY, hh:mm a"),
        }));
        this.dataTable = data;
      },
      deep: true,
    },
  },
  computed: {
    tableColumns() {
      return [
        [this.$t("stat"), "column1"],
        [this.$t("duration"), "column2"],
        [this.$t("temp", { name: "(°C)" }), "column5"],
        [this.$t("last-seen"), "date"],
      ];
    },
  },
  mixins: [tableMixin],
  components: { PaginationNew, TableSearch },
};
</script>

<style scoped>
td {
  /* border-bottom: 1px rgba(0, 0, 0, 0.1) solid; */
}

th,
td {
  min-width: 120px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"batt": "Battery {name}",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"entries": "entries",
		"last-seen": "Last Seen",
		"next": "Next",
		"no-dev": "No excursions for this period",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"temp": "Temperature {name}",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"batt": "Batería {name}",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"temp": "Temperatura {name}",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"batt": "Batterie {name}",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"temp": "Température {name}",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"batt": "Betri {name}",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"next": "Ifuatayo",
		"no-dev": "Hakuna safari za kipindi hiki",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"temp": "Halijoto {name}",
		"to": "Kwa"
	}
}
</i18n>
